import { defineComponent as _defineComponent } from 'vue'
import { ILineInfo } from "@/domain/entities/lineInfo";
import { LineTypeCode } from "@/types";
import useConvertTimeStrToMinutes from "@/use/useConvertTimeStrToMinutes";
import useGetBusStopEndTime from "@/use/useGetBusStopEndTime";
import useGetBusStopStartTime from "@/use/useGetBusStopStartTime";
import { computed, PropType } from "vue";


const __default__ = {
  name: "LineInfoDetailDepartureTime",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineInfo: {
    type: Object as PropType<ILineInfo>,
    required: true,
  },
  turnIndex: {
    type: Number,
    required: true,
  },
  departureTime: {
    type: String,
    required: true,
  },
  hasDifferentTimes: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const turnInfo = computed(() => props.lineInfo.turns[props.turnIndex]);

const isInsideShuttle = computed(
  () => props.lineInfo.lineTypeCode === LineTypeCode.Inside
);

const calculateEarlyDriveTime = (
  earlyMinute: number,
  stopTime: string
): string => {
  const timeDiffMin = useConvertTimeStrToMinutes(stopTime) - earlyMinute;
  const hours = Math.trunc(timeDiffMin / 60);
  const minutes = timeDiffMin % 60;
  const formattingHours = hours < 10 ? `0${hours}` : `${hours}`;
  const formattingMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  return `${formattingHours}:${formattingMinutes}`;
};

const getEarlyDriveTime = (earlyMinute: number) => {
  if (!isInsideShuttle.value) {
    const startTime = turnInfo.value.firstStop.departureTime;
    return calculateEarlyDriveTime(earlyMinute, startTime);
  }

  const startTime = useGetBusStopStartTime(props.lineInfo);
  const endTime = useGetBusStopEndTime(props.lineInfo);
  return `${calculateEarlyDriveTime(
    earlyMinute,
    startTime
  )}~${calculateEarlyDriveTime(earlyMinute, endTime)}`;
};

const __returned__ = { props, turnInfo, isInsideShuttle, calculateEarlyDriveTime, getEarlyDriveTime }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})